import Targeting from './Targeting';

export default Targeting;
